class Accordion extends HTMLElement {
  constructor() {
    super();
    this.details = null;
    this.summary = null;
    this.content = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.animation = null;
  }

  connectedCallback() {
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.details-rte');

    this.summary.addEventListener('click', this.onClick.bind(this));

    if (this.hasAttribute('open')) {
      this.expand();
    }

    // "Default to Open" is desktop only, so mobile starts closed. Listen for the
    // breakpoint crossing rather than `resize`: mobile browsers fire `resize`
    // whenever scrolling shows or hides the toolbar, which closed an accordion
    // mid-read.
    const mobile = window.matchMedia('(max-width: 767px)');
    const closeOnMobile = () => {
      if (mobile.matches && this.details.hasAttribute('open')) {
        this.details.removeAttribute('open');
      }
    };

    closeOnMobile();
    mobile.addEventListener('change', closeOnMobile);
  }

  onClick() {
    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      },
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    // eslint-disable-next-line no-return-assign
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 200,
        easing: 'ease',
      },
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    // eslint-disable-next-line no-return-assign
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = '';
  }
}

export default Accordion;
